export const messages = {
    en: {
        message: {
            home1: 'welcome to nsz development studio',
            home2: 'hand crafting of digital ideas',
            projects: 'check out the projects',
            about: 'I am Nicola, software developer from Italy, I have worked as sowftware engineer for various companies such as Ufirst, managing both fontend and backend technologies',
            skills: 'this is my stack',
            contact: 'feel free to contact me for any idea, info and pricing',
            addressForm: 'full address'
        }
    },
    it: {
        message: {
            home1: 'nsz development studio',
            home2: 'artigianato per idee digitali',
            projects: 'guarda i progetti',
            about: 'Sono Nicola, sviluppo software e vivo in Italia, ho lavorato in varie aziende come Ufirst, in qualità di software engineer, occupandomi di tecnologie frontend e backend',
            skills: 'le tecnologie che utilizzo',
            contact: 'contattami per qualsiasi idea, richiesta di informazioni o prezzi',
            addressForm: 'indirizzo completo'
        }
    }
};
